import React from "react";
import VideoPlayer from "../../components/VideoPlayer/VideoPlayer";
import VideoInfo from "../../components/VideoInfo/VideoInfo";
import CommentsForm from "../../components/CommentsForm/CommentsForm";
import CommentsList from "../../components/CommentList/CommentList";
import NextVideoList from "../../components/NextVideoList/NextVideoList";

import "./HomePage.scss";
import axios from "axios";
const apiLink = "https://brainflix-api-zfjp.onrender.com";
class HomePage extends React.Component {
  state = {
    videosData: [],
    selectedVideo: {},
    videoComments: [],
    loading: false,
  };
  componentDidMount() {
    this.setState({
      loading: true,
    });
    this.GetVideosData();
  }
  //gets videos list data from api and sets it to videosData state property.
  GetVideosData() {
    axios
      .get(apiLink + "/videos")
      .then((res) => {
        this.setState({
          videosData: res.data,
        });

        // this will check if there is a current video in the session storage. if it is it will set the current video to that video else will set to the first video.
        if (sessionStorage.getItem("selectedVideo")) {
          return this.GetSelectedVideo(sessionStorage.getItem("selectedVideo"));
        }
        // calling function to get all the information of the selected default video
        return this.GetSelectedVideo(res.data[0].id);
      })
      //this will have a response from the axios call made above for the information of the first video
      .then((res) => {
        this.setState({
          selectedVideo: res.data,
          videoComments: res.data.comments,
        });
        sessionStorage.setItem("selectedVideo", this.state.selectedVideo.id);
        const timeOut = setTimeout(() => {
          this.setState({
            loading: false,
          });
        }, 1500);
      })
      .catch((err) => {
        console.log(err);
      });
  }
  // returns data of specific video in a promise using id of the that video
  GetSelectedVideo(id) {
    return axios.get(apiLink + "/videos/" + id);
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.id !== prevProps.match.params.id) {
      this.setState({
        loading: true,
      });

      const selectedVideoData = this.GetSelectedVideo(
        this.props.match.params.id
      );
      selectedVideoData.then((res) => {
        //the axios response is an empty string when clicked in site logo. this condition checks if response return sends and empty string. if it is an empty string it return nothing, else updates the video.
        if (res.data === "") {
          return;
        } else {
          this.setState(
            {
              selectedVideo: res.data,
              videoComments: res.data.comments,
            },
            () => {
              //this will set the selected video to session storage to be used in case of browser refresh
              sessionStorage.setItem(
                "selectedVideo",
                this.state.selectedVideo.id
              );
              const timeOut = setTimeout(() => {
                this.setState({
                  loading: false,
                });
              }, 1500);
            }
          );
        }
      });
    }
    //scrolls up to the main video once the video is updated if the video player is not in viewport
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }
  componentWillUnmount() {
    sessionStorage.removeItem("selectedVideo");
  }

  submitComment = (e, videoId) => {
    e.preventDefault();
    const comment = e.target.comment;
    if (!comment.value.trim()) {
      comment.focus();
      comment.classList.add("form__input--error");
    } else {
      const body = {
        name: "Mohan Murunge",
        comment: comment.value,
      };
      const postComment = axios.post(
        apiLink + "/videos/" + videoId + "/comment",
        body
      );
      postComment
        .then((res) => {
          this.setState({
            videoComments: res.data.data,
          });
        })
        .catch((err) => console.log(err));
    }
  };

  render() {
    const { videosData, selectedVideo, videoComments, loading } = this.state;
    return (
      <div className="home">
        <VideoPlayer
          video={selectedVideo.video}
          img={apiLink + selectedVideo.image}
          loading={loading}
        />
        <div className="home__info">
          <div className="video__info">
            <VideoInfo
              title={selectedVideo.title}
              channel={selectedVideo.channel}
              timestamp={selectedVideo.timestamp}
              views={selectedVideo.views}
              likes={selectedVideo.likes}
              description={selectedVideo.description}
            />
            <CommentsForm
              commentsCount={videoComments && videoComments.length}
              videoId={selectedVideo && selectedVideo.id}
              submitComment={this.submitComment}
            />
            <CommentsList commentsList={videoComments} />
          </div>
          <div className="video__playlist">
            <NextVideoList
              videoLink={apiLink}
              videoList={videosData}
              selectedVideoId={selectedVideo.id}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default HomePage;
